import { useMemo } from 'react';
import { cartAtom, selectRegularItems, selectWaitingListItems } from 'src/state/cart/cartAtom';
import { useAtom } from 'ximple';
import { useSelector } from '../useSelector';

export default function useCartItemsForSummary() {
    const [cartItemsFromStore] = useAtom(cartAtom);
    const waitingListItems = useSelector(cartItemsFromStore, selectWaitingListItems);
    const regularItems = useSelector(cartItemsFromStore, selectRegularItems);

    return useMemo(() => {
        const isWaitingListMode = waitingListItems.length > 0 && regularItems.length === 0;
        const itemsToShow = isWaitingListMode ? waitingListItems : regularItems;

        return { waitingListItems, regularItems, itemsToShow, isWaitingListMode };
    }, [regularItems, waitingListItems]);
}
